/* eslint-disable import/no-unresolved */
/* eslint-disable react/self-closing-comp */
/* eslint-disable react/no-array-index-key */
/* eslint-disable eqeqeq */
/* eslint-disable no-lonely-if */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable class-methods-use-this */
/* eslint-disable no-param-reassign */
import React, { createRef } from 'react';
import './css/Hot.css';
import { Pagination, A11y } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import {
  HOT_TOURS,
  FROM_TEXT,
  NO_HOT_RESULTS,
} from '../../../Utils/Constants/HomePageConstants';
import { ReactComponent as Fire } from '../../../images/fire.svg';
import HotLoader from '../../HotsItem/HotLoader/HotLoader';
import { ReactComponent as GrayArrow } from '../../../images/gray-arrow-r.svg';
import { getHotTours } from '../../../Utils/RestUtils';
import NoResults from '../../../images/no-results.png';
import { CITY_OPTIONS } from '../../../Utils/Constants/CitiesFrom';
import { initalDepartureCity } from '../../../Utils/Constants/InitialStateUtils';
import HotItem from '../../HotItem/HotItem';

const HOT_TOURS_QUANTITY = 10;

class Hot extends React.Component {
  constructor(props) {
    super(props);
    this.swiperRef = createRef();
    this.cityButtonRef = createRef();
    this.popupRef = createRef();
    this.fetchDataCounter = 0;
    this.state = {
      activeIndex: 0,
      lastIndex: HOT_TOURS_QUANTITY - 4,

      tours: [],
      isLoading: true,
      isPopupVisible: false,

      selectedCity: initalDepartureCity,
      emptyResult: false,
    };
  }

  componentDidMount() {
    const { selectedCity } = this.state;
    this.fetchTours(selectedCity.id);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleOutsideClick, false);
    // ignore a pending hot tours response
    this.fetchDataCounter += 1;
  }

  fetchTours = (cityId) => {
    this.fetchDataCounter += 1;
    const local = this.fetchDataCounter;

    const payload = {
      from: cityId,
      to: 0,
      sort: 0,
      days: 0,
      stars: false,
      rating: false,
      isByn: false,
      aiSelected: false,
      quantity: HOT_TOURS_QUANTITY,
    };

    getHotTours(payload)
      .then((response) => {
        // skip responses of outdated requests (city was changed)
        if (local !== this.fetchDataCounter) {
          return;
        }

        if (response && response.data) {
          const { tour } = response.data.hottours;
          if (tour.length > 0) {
            this.setState({ tours: tour, emptyResult: false });
          } else {
            this.setState({ tours: tour, emptyResult: true });
          }
        }
      })
      .catch(() => {
        if (local === this.fetchDataCounter) {
          this.setState({ tours: [], emptyResult: true });
        }
      })
      .finally(() => {
        if (local === this.fetchDataCounter) {
          this.setState({ isLoading: false });
        }
      });
  };

  getSwipedTours = (tours) =>
    tours.map((tour) => (
      <SwiperSlide key={tour.tourid}>
        <HotItem tour={tour} />
      </SwiperSlide>
    ));

  getSwiperContent = () => {
    const { isLoading, tours } = this.state;
    if (isLoading) {
      return (
        <>
          <SwiperSlide>
            <HotLoader />
          </SwiperSlide>
          <SwiperSlide>
            <HotLoader />
          </SwiperSlide>
          <SwiperSlide>
            <HotLoader />
          </SwiperSlide>
          <SwiperSlide>
            <HotLoader />
          </SwiperSlide>
        </>
      );
    }

    return this.getSwipedTours(tours);
  };

  // last reachable index depends on slidesPerView of the current breakpoint
  updateLastIndex = (swiper) => {
    this.setState({
      lastIndex: HOT_TOURS_QUANTITY - swiper.params.slidesPerView,
      activeIndex: swiper.activeIndex,
    });
  };

  getSwiperItems = (ref) => (
    <Swiper
      modules={[Pagination, A11y]}
      spaceBetween={20}
      slidesPerView={2}
      onSwiper={(swiper) => {
        ref.current = swiper;
        this.updateLastIndex(swiper);
      }}
      onBreakpoint={this.updateLastIndex}
      onSlideChange={(swiper) => {
        this.setState({ activeIndex: swiper.activeIndex });
      }}
      breakpoints={{
        500: {
          slidesPerView: 3,
        },
        1024: {
          slidesPerView: 4,
        },
      }}
    >
      {this.getSwiperContent()}
    </Swiper>
  );

  slideLeft = (ref) => {
    if (ref.current) {
      ref.current.slideNext();
    }
  };

  slideRight = (ref) => {
    if (ref.current) {
      ref.current.slidePrev();
    }
  };

  getLeftButton = (ref) => {
    const { activeIndex } = this.state;

    if (activeIndex === 0) {
      return <GrayArrow className="dir_swipe_gray_arrow_left" />;
    } else {
      return (
        <button
          type="button"
          className="hot_pagination_button_l"
          onClick={() => this.slideRight(ref)}
        />
      );
    }
  };

  getRightButton = (ref) => {
    const { activeIndex, lastIndex } = this.state;

    if (activeIndex === lastIndex) {
      return <GrayArrow className="dir_swipe_gray_arrow_right" />;
    } else {
      return (
        <button
          type="button"
          className="hot_pagination_button_r"
          onClick={() => this.slideLeft(ref)}
        />
      );
    }
  };

  handleClick = () => {
    const { isPopupVisible } = this.state;
    if (!isPopupVisible) {
      // attach/remove event handler
      document.addEventListener('click', this.handleOutsideClick, false);
    } else {
      document.removeEventListener('click', this.handleOutsideClick, false);
    }

    this.setState({ isPopupVisible: !isPopupVisible });
  };

  handleOutsideClick = (e) => {
    // ignore clicks on the toggle button and inside the popup
    const button = this.cityButtonRef.current;
    const popup = this.popupRef.current;
    if (
      (button && button.contains(e.target)) ||
      (popup && popup.contains(e.target))
    ) {
      return;
    }

    this.handleClick();
  };

  selectCity = (city) => {
    const { selectedCity } = this.state;

    this.handleClick();

    if (city.id != selectedCity.id) {
      if (this.swiperRef.current) {
        this.swiperRef.current.slideTo(0, 0);
      }

      this.setState({
        selectedCity: city,
        isLoading: true,
        emptyResult: false,
        activeIndex: 0,
      });
      this.fetchTours(city.id);
    }
  };

  render() {
    const { isPopupVisible, selectedCity, emptyResult } = this.state;

    return (
      <div className="hot_w">
        <div className="containerW">
          <div className="hot_title_w">
            <div className="hot_title">{HOT_TOURS}</div>
            <Fire className="hot_fire_ico" />
          </div>
          <div className="hot_from_line">
            <div className="hot_from_w">
              <div className="hot_from_text">{`${FROM_TEXT}:`}</div>
              <button
                ref={this.cityButtonRef}
                type="button"
                className="hot_from_city"
                onClick={this.handleClick}
              >
                {selectedCity.name}
              </button>
              {isPopupVisible && (
                <div ref={this.popupRef} className="hot_popup_w">
                  {CITY_OPTIONS.map((city, index) => (
                    <button
                      key={`city-${index}`}
                      type="button"
                      onClick={() => this.selectCity(city)}
                      className="hot_city_but br_text_18"
                    >
                      {city.name}
                    </button>
                  ))}
                </div>
              )}
            </div>

            <div className="hot_pagination_button_w">
              {this.getLeftButton(this.swiperRef)}
              {this.getRightButton(this.swiperRef)}
            </div>
          </div>
          <div>
            <div>{this.getSwiperItems(this.swiperRef)}</div>
            {emptyResult && (
              <div className="hot_no_res">
                <img src={NoResults} alt="" className="mb_5" />
                <div className="br_text_18">{NO_HOT_RESULTS}</div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default Hot;
